import CenterHeartIcon from "./CenterHeartIcon";

const InterestScreenIcons={
    CenterHeartIcon
}
export default InterestScreenIcons